import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  type BulkBillDlnItemsPayload,
  type BulkBillDlnItemsResponse,
} from './types';
import {
  zodBulkBillDlnItemsBodySchema,
  zodBulkBillDlnItemsEndpointSchema,
  zodSuccessResponseSchema,
} from './validations';

/**
 * Bulk-bills delivery note items for a given asset ID.
 *
 * @param assetId - The delivery note asset ID.
 * @param payload - The items to bill with billed quantity factors.
 * @param options - Optional request options (e.g. abort signal).
 * @returns The API success response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Delivery-Note/operation/bulk_bill_dln_items_delivery_note__asset_id__item_bulk_bill_put
 */
export const bulkBillDlnItems = async (
  assetId: UUID,
  payload: BulkBillDlnItemsPayload,
  options?: KyRequestOptions,
) => {
  const response = await vestigasApi
    .put(ENDPOINT.DELIVERY_NOTE.BULK_BILL_ITEMS(assetId), {
      json: payload,
      validate: {
        body: zodBulkBillDlnItemsBodySchema,
        pathSegments: zodBulkBillDlnItemsEndpointSchema,
      },
      ...options,
    })
    .json<BulkBillDlnItemsResponse>();

  return zodSuccessResponseSchema.parse(response);
};
